export function PropertyTypesWeBuy() {
  const propertyTypes = [
    {
      title: 'Duplexes (2 Units)',
      description: 'We purchase all types of duplex properties, including side-by-side configurations, up-down layouts, and detached units on the same lot. Whether your duplex is owner-occupied with one rental unit or fully rented, we can make you a fair cash offer.',
      features: [
        'Side-by-side duplexes with shared walls',
        'Stacked duplexes with separate entrances',
        'Detached units on single property',
        'Owner-occupied or fully rented',
        'Any age or architectural style',
        'Properties needing repairs or updates'
      ],
      image: 'https://public.readdy.ai/ai/img_res/3b32cb6204a54345eed9f870298287e9.jpg'
    },
    {
      title: 'Triplexes (3 Units)',
      description: 'Triplex properties offer excellent income potential with three separate rental units. We buy triplexes in all configurations and conditions, from well-maintained properties to those requiring significant renovation work.',
      features: [
        'Three-story vertical configurations',
        'Side-by-side and mixed layouts',
        'Converted single-family homes',
        'Properties with mixed unit sizes',
        'Buildings with deferred maintenance',
        'Partially or fully vacant triplexes'
      ],
      image: 'https://readdy.ai/api/search-image?query=triplex%20apartment%20building%20three%20units%20multifamily%20property%2C%20residential%20rental%20building%2C%20professional%20real%20estate%20photography%2C%20investment%20property%20with%20clean%20simple%20background&width=500&height=400&seq=triplex-type-001&orientation=landscape'
    },
    {
      title: 'Quadplexes (4 Units)',
      description: 'Four-unit apartment buildings represent the sweet spot for many investors. We actively purchase quadplexes of all types, ages, and conditions throughout the United States, providing quick closings and fair market valuations.',
      features: [
        'Four separate rental units',
        'Various floor plan configurations',
        'Properties with 1-3 bedroom units',
        'Buildings from any era',
        'Occupied or vacant properties',
        'Properties with tenant issues'
      ],
      image: 'https://readdy.ai/api/search-image?query=quadplex%20fourplex%20apartment%20building%20four%20units%2C%20small%20multifamily%20residential%20property%2C%20professional%20real%20estate%20photography%2C%20rental%20investment%20property%20with%20clean%20simple%20background&width=500&height=400&seq=quadplex-type-001&orientation=landscape'
    },
    {
      title: '5-Unit Apartment Buildings',
      description: 'Five-unit properties bridge the gap between small multifamily and larger apartment complexes. These properties offer strong income potential with diversified tenant base, and we purchase them in any condition or occupancy status.',
      features: [
        'Five independent rental units',
        'Single or multiple building structures',
        'Properties with parking facilities',
        'Buildings with common areas',
        'Any occupancy level accepted',
        'Properties with management challenges'
      ],
      image: 'https://readdy.ai/api/search-image?query=five%20unit%20small%20apartment%20building%20multifamily%20property%2C%20residential%20rental%20complex%2C%20professional%20real%20estate%20photography%2C%20investment%20property%20with%20clean%20simple%20background&width=500&height=400&seq=five-unit-type-001&orientation=landscape'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Types of Small Apartment Buildings We Purchase
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            From duplexes to five-unit buildings, we buy all types of small multifamily properties in any condition, location, or occupancy status.
          </p>
        </div>

        <div className="space-y-12">
          {propertyTypes.map((type, index) => (
            <div 
              key={index}
              className={`grid lg:grid-cols-2 gap-8 items-center ${index % 2 === 1 ? 'lg:flex-row-reverse' : ''}`}
            >
              <div className={index % 2 === 1 ? 'lg:order-2' : ''}>
                <h3 className="text-3xl font-bold text-gray-900 mb-4">{type.title}</h3>
                <p className="text-lg text-gray-600 mb-6">{type.description}</p>
                <ul className="space-y-3">
                  {type.features.map((feature, fIndex) => (
                    <li key={fIndex} className="flex items-start">
                      <i className="ri-checkbox-circle-fill text-orange-500 text-xl mr-3 mt-1"></i>
                      <span className="text-gray-700">{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
              <div className={index % 2 === 1 ? 'lg:order-1' : ''}>
                <img 
                  src={type.image}
                  alt={type.title}
                  className="w-full h-full object-cover rounded-xl shadow-lg"
                />
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-gradient-to-br from-orange-500 to-orange-600 rounded-2xl p-8 lg:p-12 text-white">
          <div className="max-w-4xl mx-auto text-center">
            <h3 className="text-3xl lg:text-4xl font-bold mb-6">
              We Buy Small Apartment Complexes Too
            </h3>
            <p className="text-xl mb-8 opacity-95">
              In addition to individual small apartment buildings, we also purchase small apartment complexes consisting of multiple buildings with 6-20 total units. If you own a small apartment complex that you're looking to sell quickly for cash, we'd love to discuss your property and provide you with a no-obligation offer.
            </p>
            <a 
              href="#get-offer"
              className="inline-flex items-center justify-center px-8 py-4 bg-white text-orange-600 font-semibold rounded-lg hover:bg-gray-100 transition-colors whitespace-nowrap"
            >
              Get Your Cash Offer Today
              <i className="ri-arrow-right-line ml-2"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}